'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactNotificationSystem = require('react-notification-system');

var _reactNotificationSystem2 = _interopRequireDefault(_reactNotificationSystem);

var _notifications = require('redux/modules/notifications');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = exports.App = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App(props) {
    (0, _classCallCheck3.default)(this, App);

    var _this = (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).call(this, props));

    _this._setNotificationSystem = function (notificationSystem) {
      _this.notificationSystem = notificationSystem;
    };

    _this.notificationSystem = null;
    return _this;
  }

  (0, _createClass3.default)(App, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var notifications = nextProps.notifications;

      var notificationIds = notifications.map(function (notification) {
        return notification.uid;
      });

      // Get all active notifications from react-notification-system
      // and remove all where uid is not found in the reducer
      var notificationSystemState = this.notificationSystem.state;
      var notificationSystemNotifications = notificationSystemState && notificationSystemState.notifications || [];

      notificationSystemNotifications.forEach(function (notification) {
        if (notificationIds.indexOf(notification.uid) < 0) {
          _this2.notificationSystem.removeNotification(notification.uid);
        }
      });

      notifications.forEach(function (notification) {
        _this2.notificationSystem.addNotification((0, _extends3.default)({}, notification, {
          onRemove: function onRemove() {
            nextProps.hide(notification.uid);
            if (typeof notification.onRemove === 'function') notification.onRemove();
          }
        }));
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          notifications = _props.notifications,
          rest = (0, _objectWithoutProperties3.default)(_props, ['notifications']); // eslint-disable-line no-unused-vars

      return _react2.default.createElement(_reactNotificationSystem2.default, (0, _extends3.default)({ ref: this._setNotificationSystem, style: this.style }, rest));
    }
  }, {
    key: 'style',
    get: function get() {
      var defaultWidth = this.props.width || 320;
      var defaultShadowOpacity = this.props.shadowOpacity || '1';
      var defaultColors = this.props.colors || {
        success: {
          hex: '#78BE20',
          rgb: '120, 190, 32'
        },
        info: {
          hex: '#005D8C',
          rgb: '0, 93, 140'
        },
        error: {
          hex: '#C81423',
          rgb: '200, 20, 35'
        },
        warning: {
          hex: '#F39A26',
          rgb: '243, 154, 38'
        }
      };
      return {
        // ROOT ITEM
        Containers: {
          DefaultStyle: {
            width: defaultWidth
          },
          tc: {
            marginLeft: -(defaultWidth / 2)
          },
          bc: {
            marginLeft: -(defaultWidth / 2)
          }
        },

        // NOTIFICATION ITEM
        NotificationItem: {
          DefaultStyle: {
            borderRadius: '0px'
          },

          success: {
            borderTop: '5px solid ' + defaultColors.success.hex,
            WebkitBoxShadow: '0 0 0 1px rgba(' + defaultColors.success.rgb + ', ' + defaultShadowOpacity + ')',
            MozBoxShadow: '0 0 0 1px rgba(' + defaultColors.success.rgb + ', ' + defaultShadowOpacity + ')',
            boxShadow: '0 0 0 1px rgba(' + defaultColors.success.rgb + ', ' + defaultShadowOpacity + ')'
          },

          info: {
            borderTop: '5px solid ' + defaultColors.info.hex,
            WebkitBoxShadow: '0 0 0 1px rgba(' + defaultColors.info.rgb + ', ' + defaultShadowOpacity + ')',
            MozBoxShadow: '0 0 0 1px rgba(' + defaultColors.info.rgb + ', ' + defaultShadowOpacity + ')',
            boxShadow: '0 0 0 1px rgba(' + defaultColors.info.rgb + ', ' + defaultShadowOpacity + ')'
          },

          error: {
            borderTop: '5px solid ' + defaultColors.error.hex,
            WebkitBoxShadow: '0 0 0 1px rgba(' + defaultColors.error.rgb + ', ' + defaultShadowOpacity + ')',
            MozBoxShadow: '0 0 0 1px rgba(' + defaultColors.error.rgb + ', ' + defaultShadowOpacity + ')',
            boxShadow: '0 0 0 1px rgba(' + defaultColors.error.rgb + ', ' + defaultShadowOpacity + ')'
          },

          warning: {
            borderTop: '5px solid ' + defaultColors.warning.hex,
            WebkitBoxShadow: '0 0 0 1px rgba(' + defaultColors.warning.rgb + ', ' + defaultShadowOpacity + ')',
            MozBoxShadow: '0 0 0 1px rgba(' + defaultColors.warning.rgb + ', ' + defaultShadowOpacity + ')',
            boxShadow: '0 0 0 1px rgba(' + defaultColors.warning.rgb + ', ' + defaultShadowOpacity + ')'
          }
        },
        // TITLE ITEM
        Title: {
          success: {
            color: defaultColors.success.hex
          },

          error: {
            color: defaultColors.error.hex
          },

          warning: {
            color: defaultColors.warning.hex
          },

          info: {
            color: defaultColors.info.hex
          }
        }
      };
    }
  }]);
  return App;
}(_react.Component), _class.propTypes = {
  notifications: _react.PropTypes.array,
  width: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  shadowOpacity: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  colors: _react.PropTypes.object,
  hide: _react.PropTypes.func
}, _class.defaultProps = {
  notifications: [],
  hide: function hide() {}
}, _temp);


var mapStateToProps = function mapStateToProps(state) {
  return {
    notifications: state.notifications.current
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { hide: _notifications.hide })(App);


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotificationSystem/NotificationSystem.jsx
// module id = 1639
// module chunks = 0